import type { ReactNode } from "react";
import { AlertTriangle, Plug } from "lucide-react";

/**
 * Every consent-page screen that is not the question itself: the request was
 * refused, it did not load, or there was no request in the address at all. One
 * icon, one title, one or two lines and the way out, in the shape the other
 * account-flow pages use (VerifyEmailPage, ConfirmDeletePage).
 */
export function ConnectNotice({
  tone,
  title,
  body,
  detail,
  actions,
}: {
  tone: "info" | "error";
  title: string;
  body: string;
  /** A second, quieter line: the server's own reason. */
  detail?: string | null;
  actions: ReactNode;
}) {
  const Icon = tone === "error" ? AlertTriangle : Plug;
  return (
    <div className="flex flex-col items-center gap-4 py-2 text-center">
      <Icon className={tone === "error" ? "size-8 text-destructive" : "size-8 text-primary"} aria-hidden />
      <h1 className="text-xl font-bold tracking-tight">{title}</h1>
      <p className="text-sm text-foreground">{body}</p>
      {detail && <p className="break-words text-xs text-muted-foreground">{detail}</p>}
      <div className="flex w-full flex-col gap-2">{actions}</div>
    </div>
  );
}
